function customPattern(str) {
  var pattern = str.split('').map(function(char) {
    return !['-', '/', '.', ',', ' '].includes(char)
      ? '\\d'
      : char === '/'
      ? '\\/'
      : char
  })
  return new RegExp('^' + pattern.join('') + '$')
}

module.exports = customPattern
